import api from '@/apis/api';
import getMessageFromApiError from '@/util/getMessageFromApiError';

export const getProjectAuthorizers = async (project_uuid) => {
  try {
    const res = await api.get(`/project/${project_uuid}/authorizers`);
    return res.data;
  } catch (error) {
    const message = getMessageFromApiError(error);
    throw new Error(`API Error - ${message}`);
  }
};

export const getProjectAuthorizer = async (project_uuid, authorizer_id) => {
  try {
    const res = await api.get(
      `/project/${project_uuid}/authorizers/${authorizer_id}`,
    );
    return res.data;
  } catch (error) {
    const message = getMessageFromApiError(error);
    throw new Error(`API Error - ${message}`);
  }
};

export const createProjectAuthorizer = async (project_uuid, values) => {
  try {
    const res = await api.post(
      `/project/${project_uuid}/authorizers`,
      values,
    );
    return res.data;
  } catch (error) {
    const message = getMessageFromApiError(error);
    throw new Error(`API Error - ${message}`);
  }
};

export const updateProjectAuthorizer = async (
  project_uuid,
  authorizer_id,
  values,
) => {
  try {
    const res = await api.patch(
      `/project/${project_uuid}/authorizers/${authorizer_id}`,
      values,
    );
    return res.data;
  } catch (error) {
    const message = getMessageFromApiError(error);
    throw new Error(`API Error - ${message}`);
  }
};

export const deleteProjectAuthorizer = async (project_uuid, authorizer_id) => {
  try {
    const res = await api.delete(
      `/project/${project_uuid}/authorizers/${authorizer_id}`,
    );
    return res.data;
  } catch (error) {
    const message = getMessageFromApiError(error);
    throw new Error(`API Error - ${message}`);
  }
};
